// Modules: hotelRooms «الغرف» and hotelReservations «الحجوزات» (board 27 §أ,
// HANDOFF-erp-web §17). Both behind `erp.hotel` — the server's modgate
// refuses, the client hides (rule 6: off = absent). «الغرف» sits first in the
// rail; «الحجوزات» takes the place of «المواعيد» (`replacesRail`: today ·
// calendar · booking leave the rail, their routes stay). The rail's
// «المراجعون» reads «النزلاء» through the hotel term profile — the customers
// module itself is untouched. Reception = staff (HANDOFF §17 roles); the
// setup rows carry their own role and flag (menu.ts).

import { BedDouble, CalendarCheck } from 'lucide-react';
import { defineModule } from '@/app/module-types';
import { RESERVATIONS_MENU, ROOMS_MENU } from './menu';
import { reservationsRoutes, roomsRoutes } from './routes';

export const hotelRooms = defineModule({
  key: 'hotelRooms',
  label: 'الغرف',
  icon: BedDouble,
  flag: 'erp.hotel',
  minRole: 'staff',
  rail: 'rooms',
  routes: roomsRoutes,
  menu: ROOMS_MENU,
});

export const hotelReservations = defineModule({
  key: 'hotelReservations',
  label: 'الحجوزات',
  icon: CalendarCheck,
  flag: 'erp.hotel',
  minRole: 'staff',
  rail: 'reservations',
  replacesRail: 'appointments',
  routes: reservationsRoutes,
  menu: RESERVATIONS_MENU,
});
